import { useState } from 'react';

import { Input } from '@trackman/web-shared-components';

import { FilterType } from '../FilterType';
import { AppButton } from 'components/form';
import { t } from 'utilities/TranslationUtils';

type TextFieldsFilterProps = {
  filter: { inputs: any[]; type: string };
  onApply: (value?: any) => void;
};

export const TextFieldsFilter = ({ filter, onApply }: TextFieldsFilterProps) => {
  const [values, setValues] = useState<Record<string, string>>({});

  return (
    <div className='data-table-filter-content gap-10px'>
      {filter?.inputs?.map((single, i) => {
        return (
          <Input
            key={i}
            label={single?.label || ''}
            defaultValue={values?.[i] || ''}
            autoFocus={true}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const newValues = { ...(values || {}) };
              newValues[single.id] = e.currentTarget.value;
              setValues(newValues);
            }}
            onKeyDown={(e) => e.key === 'Enter' && onApply(values)}
          />
        );
      })}

      <AppButton
        data-test='ApplyTextFieldFilterSubmit'
        type='button'
        className='apply-button '
        variant='primary'
        onClick={() => onApply(values)}
      >
        {t('common.apply')}
      </AppButton>
    </div>
  );
};

export default TextFieldsFilter;
